<template>
  <!-- 用户授权书 -->
  <div class="my-agree">
    <div class="item-list">
      <div class="item-href" v-track="{ functionName: 'iEP用户协议' }" @click="handleClickGo('UserAgreement')">
        <div class="href-txt">《iEP用户协议》</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div>
      <div class="item-href" v-track="{ functionName: '隐私声明' }" @click="handleClickGo('POWER')">
        <div class="href-txt">《隐私声明》</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div>
      <div class="item-href" v-if="`${userInfo.memberType}` === '0'" v-track="{ functionName: '远程带教协议' }" @click="handleClickGo('RemoteTeaching')">
        <div class="href-txt">《远程带教协议》</div>
        <img src="@/assets/images/person/right3.png" class="icon-right" alt="">
      </div>
    </div>
    <van-overlay :show="isRemote" @click="isRemote = false">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">应用授权</div>
        <div class="wrap-con">
          远程带教系统将获取您iEP上的基本信息,用于进行身份验证。
          <br />
          <br />
          您可阅读
          <span class="href-txt" @click="handleCarto">《Carto远程服务协议》</span>
          了解详细信息。如您同意，请点击“同意授权”进行授权。
        </div>
        <div class="warp-btn">
          <div class="btn btn1" @click="isRemote = false">取消</div>
          <div class="btn btn2" @click="isHospital = true; isRemote = false">同意授权</div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="isHospital" @click="isHospital = false">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">确认信息</div>
        <div class="wrap-con">
          <div class="wrap-txt wrap-txt2">授权医院：{{ userInfo && userInfo.hospitalName }}</div>
          <div class="wrap-txt3">如信息有误，可点击修改</div>
        </div>
        <div class="warp-btn">
          <div class="btn btn1" @click="isHospital = false">取消</div>
          <div class="btn btn2" @click="handleRemote">确定</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
import { addUserhospauth, getAuthStatus } from '@/api/person'
const UserProfile = {
  name: 'agree',
  data () {
    return {
      isRemote: false,
      isHospital: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
  },
  mounted () {
    // 获取用户是否授权远程带教
    getAuthStatus({
      userId: this.userInfo.id
    }).then(res => {
      this.boolRemote = res.data
    })
  },
  methods: {
    // 同意授权远程
    handleRemote () {
      addUserhospauth({
        hospital: this.userInfo.hospitalName,
        hospitalCustCd: this.userInfo.hospitalId,
        veevaMultiCode: this.userInfo.multiCode,
        authStatus: 1,
        userId: this.userInfo.id,
      }).then(res => {
        this.$router.push({
          path: '/distanceEducation',
        })
      })
    },
    handleCarto() {
      this.$router.push({
        path: '/cartoDictonary',
        query: {
          // hospitalName: this.list[0].hospital,
          // createTime: this.list[0].createTime
        }
      })
    },
    handleClickGo (type) {
      const obj = {
        path: '/agreeDetailPage',
        query: {}
      }
      switch (type) {
        case 'UserAgreement':
          obj.query.typeArgee = 'UserAgreement'
          obj.query.fromPage = 'person'
          obj.query.type = 1
          break
        case 'POWER':
          obj.query.typeArgee = 'POWER'
          obj.query.fromPage = 'person'
          obj.query.type = 2
          break
        case 'RemoteTeaching':
          if (this.boolRemote) {
            localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/distanceEducation`)
            this.$router.push({
              path: '/distanceEducation'
            })
          } else {
            this.isRemote = true
          }
          return
      }
      this.$router.push(obj)
    },
  },
}
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-agree {
  background-color: #F9F8F7;
  background-repeat: no-repeat;
  background-size: 100%;
  min-height: 100vh;
  padding: 16px 20px;
  box-sizing: border-box;
  .item-list {
    background-color: #fff;
    box-shadow: 0px 2px 9px 0px rgba(0,0,0,0.05);
    border-radius: 9px 9px 9px 9px;
  }
}
.item-href {
  margin-bottom: 8px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0px 15px 30px 0px rgba(245, 248, 252, 0.25);
  padding: 0 14px;
  box-sizing: border-box;

  .href-icon {
    width: 23px;
    height: 23px;
    display: block;
  }

  .href-txt {
    flex: 1;
    margin-left: 11px;
    font-size: 13px;
    color: #212226;

    &.mini {
      color: #EB1700;
      font-weight: 500;
    }
  }

  .icon-right {
    width: 13px;
    height: 13px;
    display: block;
  }
}

/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    box-sizing: border-box;

    .img-wrap {
      width: 80px;
      display: block;
      margin-bottom: 18px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .wrap-txt {
      font-size: 17px;
      line-height: 24px;
      font-weight: 500;
      color: #000000;
      margin-bottom: 30px;
      text-align: center;

      &.wrap-txt2 {
        border-bottom: 1px solid #A9AEB6;
        padding-bottom: 10px;
        box-sizing: border-box;
        text-align: left;
        margin-bottom: 14px;
      }
    }

    .wrap-txt3 {
      position: relative;

      &::before {
        content: '*';
        font-size: 17px;
        color: #FF0000;
        width: 9px;
        text-align: center;
        display: inline-block;
      }
    }

    .wrap-con {
      width: 266px;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 16px;
      margin-bottom: 30px;

      .href-txt {
        color: #EB1700;
      }
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      height: 55px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/agreeList.vue